/*
包含n个用于直接更新状态的方法的对象模块
 */

import {  SAVE_USER_INFO,  ON_HTTP_ERROR,CURR_AREA_CODE,TOMCAT_INFO} from './mutation-types'

export default {
   [ON_HTTP_ERROR](state, payload) {
     state.httpError = payload
   },
   [SAVE_USER_INFO](state, userInfo) {
     state.user = userInfo
   },
   [CURR_AREA_CODE](state, curAreaCode) {
     state.currAreaCode = curAreaCode
   },
   [TOMCAT_INFO](state, tomcatInfo) {
     state.tomcatInfo = tomcatInfo
   },
  
}




// WEBPACK FOOTER //
// ./src/vuex/mutations.js